import React from "react";
import "./css/Contact.css";
import { FaLinkedin, FaInstagram, FaGithub, FaEnvelope, FaYoutube } from "react-icons/fa";
import { motion } from "framer-motion";

export default function Contact() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      style={{ minHeight: "100vh" }}
       className="contact-bg"
    >
    <section className="contact-footer-section">
      <div className="contact-card">
        <h2 className="contact-heading">Let’s Connect!</h2>
        <p className="contact-desc">
          Want to collaborate or have a question? Reach out via social media or send an email.
        </p>
        <div className="contact-social-list">
          <a href="https://www.linkedin.com/in/milindparitshinde/" target="_blank" rel="noopener noreferrer" className="contact-social linkedin">
            <FaLinkedin />
            LinkedIn
          </a>
          <a href="https://www.instagram.com/milind_shinde9/" target="_blank" rel="noopener noreferrer" className="contact-social instagram">
            <FaInstagram />
            Instagram
          </a>
          <a href="https://github.com/milindparitshinde/" target="_blank" rel="noopener noreferrer" className="contact-social github">
            <FaGithub />
            GitHub
          </a>
          <a href="mailto:your@email.com" target="_blank" rel="noopener noreferrer" className="contact-social email">
            <FaEnvelope />
            Email
          </a>
          <a href="https://www.youtube.com/@techbull.ai." target="_blank" rel="noopener noreferrer" className="contact-social youtube">
            <FaYoutube />
            YouTube
          </a>
        </div>
      </div>
      {/* Footer Bar */}
      <footer className="site-footer">
        <div className="footer-content">
          <span>
            © {new Date().getFullYear()} Your Name. All rights reserved.
          </span>
          <span>
            Built with <a href="https://react.dev" target="_blank" rel="noopener noreferrer">React  </a>
            + <a href="https://www.djangoproject.com/" target="_blank" rel="noopener noreferrer"> Django</a>
          </span>
        </div>
      </footer>
    </section>
    </motion.section>
  );
}
